function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="26" height="17" viewBox="0 0 26 19" xmlns="http://www.w3.org/2000/svg" {...props}><g fill="none" fillRule="evenodd"><path fill="#5AB457" d="M12.644 0v17H.175z" /><path fill="#438941" d="M12.644 0v17h12.468z" /></g></svg>;
});